var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "liff-page-array-editor"
  }, [_vm._l(_vm.pageItems, function (page, index) {
    return _c('div', {
      key: page.pageKey,
      staticClass: "page-item mb-4"
    }, [_c('div', {
      staticClass: "page-header d-flex align-items-center mb-3"
    }, [_c('span', {
      staticClass: "page-order badge badge-primary mr-2"
    }, [_vm._v(_vm._s(index + 1))]), _c('span', {
      staticClass: "page-key-label flex-grow-1"
    }, [_vm._v(_vm._s(page.pageKey))]), _c('div', {
      staticClass: "page-actions d-flex flex-shrink-0 ml-3"
    }, [_c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm",
        "title": "刪除此頁面"
      },
      on: {
        "click": function click($event) {
          return _vm.confirmRemovePage(page.pageKey);
        }
      }
    }, [_c('i', {
      staticClass: "mdi mdi-delete"
    })])], 1)]), _c('div', {
      staticClass: "page-meta mb-3"
    }, [_c('b-form-row', _vm._l(page.metaFields, function (field) {
      return _c('b-col', {
        key: field.key,
        staticClass: "mb-2",
        attrs: {
          "cols": "12"
        }
      }, [_c('b-form-group', {
        staticClass: "mb-0",
        attrs: {
          "label-cols": "12",
          "label-cols-lg": "3",
          "label-size": "sm",
          "label": field.label,
          "label-class": "page-meta-label py-1"
        }
      }, [field.type === 'boolean' ? _c('b-form-checkbox', {
        staticClass: "pt-1",
        attrs: {
          "value": true,
          "unchecked-value": false
        },
        model: {
          value: _vm.form[_vm.fullKey(page.pageKey, field.key)],
          callback: function callback($$v) {
            _vm.$set(_vm.form, _vm.fullKey(page.pageKey, field.key), $$v);
          },
          expression: "form[fullKey(page.pageKey, field.key)]"
        }
      }) : _c('b-form-input', {
        attrs: {
          "size": "sm",
          "placeholder": field.placeholder || ''
        },
        model: {
          value: _vm.form[_vm.fullKey(page.pageKey, field.key)],
          callback: function callback($$v) {
            _vm.$set(_vm.form, _vm.fullKey(page.pageKey, field.key), $$v);
          },
          expression: "form[fullKey(page.pageKey, field.key)]"
        }
      })], 1)], 1);
    }), 1)], 1), _c('div', {
      staticClass: "page-content"
    }, [_c('div', {
      staticClass: "page-meta-label mb-1"
    }, [_vm._v("頁面內容")]), _c('ckeditor', {
      attrs: {
        "editor": _vm.editor,
        "config": _vm.editorConfig
      },
      model: {
        value: _vm.form[_vm.fullKey(page.pageKey, 'content')],
        callback: function callback($$v) {
          _vm.$set(_vm.form, _vm.fullKey(page.pageKey, 'content'), $$v);
        },
        expression: "form[fullKey(page.pageKey, 'content')]"
      }
    })], 1)]);
  }), _c('div', {
    staticClass: "add-page-btn mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.openAddModal
    }
  }, [_c('i', {
    staticClass: "mdi mdi-plus mr-1"
  }), _vm._v(" 新增頁面 ")])], 1), _c('b-modal', {
    attrs: {
      "id": "add-liff-page-modal",
      "title": "新增頁面",
      "ok-disabled": !_vm.newPageKey || _vm.newPageKeyDuplicated,
      "ok-title": "確認新增",
      "cancel-title": "取消"
    },
    on: {
      "ok": _vm.confirmAddPage,
      "hidden": _vm.resetNewPageKey
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "頁面識別代號 (path_key)",
      "label-size": "sm",
      "description": "僅允許英文小寫、數字與底線，例如：event_page。建立後無法更改。",
      "state": _vm.newPageKeyState,
      "invalid-feedback": _vm.newPageKeyError
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "例如：advocate_page",
      "state": _vm.newPageKeyState,
      "autofocus": ""
    },
    model: {
      value: _vm.newPageKey,
      callback: function callback($$v) {
        _vm.newPageKey = $$v;
      },
      expression: "newPageKey"
    }
  })], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }